import React, { Component } from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import LoadingSpinner from '../loading-spinner/LoadingSpinner';
import {RouteConstants} from "../route/services/RouteConstants";
import * as actions from './ducks/actions';
import auth from "../../services/auth/AuthProvider";

class OtcAuthCallback extends Component {

    handleAuthentication = () => {
        // if (/access_token|id_token|error/.test(this.props.location.hash)) {
        auth.handleAuthentication().then(authResult => {
            let userProfile = authResult.idTokenPayload;
            if (userProfile) {
                this.props.setUserProfile(userProfile);
                if (userProfile.userAccountId && localStorage.getItem('myb_heap_app_id') && window.heap) {
                    window.heap.identify(userProfile.userAccountId, 'uuid')
                }
                this.props.history.push(RouteConstants.DASHBOARD);
            }

        }).catch(err => {
            console.log(err);
            this.props.history.push(RouteConstants.AUTH_ERROR)
        });
    };

    componentDidMount() {
        this.handleAuthentication();
    }

    render() {
        return (
            <LoadingSpinner />
        );
    }
}

OtcAuthCallback.propTypes = {
  setUserProfile: PropTypes.func.isRequired
};

const mapStateToProps = (state) => {
  return {}
};

export default connect(
    mapStateToProps,
    actions
)(OtcAuthCallback);